import { createContext } from "react";

const RuralContext = createContext();

export default RuralContext;
